// extracted by mini-css-extract-plugin
module.exports = {"userAlertIconAvatarIcon":"UserAlertIcon_userAlertIconAvatarIcon__9GpeD","userAlertIconAvatarImage":"UserAlertIcon_userAlertIconAvatarImage__C_2PN"};